(() => {
  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'INR';
    const locale = document.documentElement.lang || 'en-IN';
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      maximumFractionDigits: 2
    }).format(Number(cents || 0) / 100);
  };

  const initialise = (bar) => {
    if (bar.dataset.mobilePurchaseBarInitialised === 'true') return;
    bar.dataset.mobilePurchaseBarInitialised = 'true';

    const form = bar.closest('[data-product-form]');
    if (!form) return;

    const quantityInput = form.querySelector('input[name="quantity"]');
    const mainAddButton = form.querySelector('[name="add"]');
    const variantInput = form.querySelector('[data-selected-variant-id]');
    const variantsNode = form.querySelector('[data-variants-json]');
    const packSelect =
      form.querySelector('[data-pack-size-option]') ||
      form.querySelector('[data-product-option]');
    const priceNode = bar.querySelector('[data-mobile-product-price]');
    const packNode = bar.querySelector('[data-mobile-pack-size]');
    const quantityNode = bar.querySelector('[data-mobile-quantity]');
    const minusButton = bar.querySelector('[data-mobile-quantity-minus]');
    const plusButton = bar.querySelector('[data-mobile-quantity-plus]');
    const addButton = bar.querySelector('[data-mobile-add-to-cart]');
    let variants = [];

    try {
      variants = JSON.parse(variantsNode?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const selectedVariant = () =>
      variants.find((variant) => String(variant.id) === String(variantInput?.value));

    const update = () => {
      const quantity = Math.max(1, parseInt(quantityInput?.value || '1', 10) || 1);
      const variant = selectedVariant();

      if (quantityInput) quantityInput.value = quantity;
      if (quantityNode) quantityNode.textContent = quantity;
      if (packNode) packNode.textContent = packSelect?.value || 'Standard pack';
      if (priceNode && variant) priceNode.textContent = money(variant.price);

      const available = variant ? variant.available : !mainAddButton?.disabled;
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available
          ? (mainAddButton?.dataset.addText || 'Add to cart')
          : (mainAddButton?.dataset.soldText || 'Sold out');
      }
    };

    const setQuantity = (value) => {
      if (!quantityInput) return;
      quantityInput.value = Math.max(1, value);
      quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      update();
    };

    minusButton?.addEventListener('click', () => {
      setQuantity((parseInt(quantityInput?.value || '1', 10) || 1) - 1);
    });
    plusButton?.addEventListener('click', () => {
      setQuantity((parseInt(quantityInput?.value || '1', 10) || 1) + 1);
    });
    addButton?.addEventListener('click', () => {
      if (!mainAddButton?.disabled) mainAddButton?.click();
    });

    quantityInput?.addEventListener('input', update);
    quantityInput?.addEventListener('change', update);
    packSelect?.addEventListener('change', () => window.requestAnimationFrame(update));
    form.addEventListener('variant:change', update);
    update();
  };

  const boot = () =>
    document.querySelectorAll('[data-mobile-purchase-bar]').forEach(initialise);

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
